export class Category {
    CategoryId: number;
    CategoryName: string;
    highlighted?: boolean;
    hovered?: boolean;
}
